import { useQuery } from '@tanstack/react-query';

import { myScholarshipMembersKey, requestMyScholarshipMembers } from './membersApi';

/**
 * The rows of the directory's Scholarship Members view, at the app's default staleness.
 *
 * No `Failure` variant to handle: `myScholarshipMembers` is a pure read, so infrastructure errors
 * travel the standard GraphQL errors envelope, and the directory shows them as its error state.
 */
export function useMyScholarshipMembers() {
  return useQuery({ queryKey: myScholarshipMembersKey, queryFn: requestMyScholarshipMembers });
}
